/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumEditAttachment.vue?vue&type=template&id=2dcde2ba&scoped=true"
import script from "./ForumEditAttachment.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumEditAttachment.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumEditAttachment.vue?vue&type=style&index=0&id=2dcde2ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcde2ba",
  null
  
)

export default component.exports